// extracted by mini-css-extract-plugin
export default {"awardsTab":"CreateChampionshipTabs_awardsTab__jT0Df","tabsContainer":"CreateChampionshipTabs_tabsContainer__5Ke08"};